import { useEffect, useState } from "react";
import { fetchList } from "../api";

export function useFetchList(
  endpoint,
  { headers = {}, params = {}, skip = false } = {}
) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (skip || !endpoint) return;
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    fetchList(endpoint, { headers, params, signal: controller.signal })
      .then((rows) => setData(rows))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
    return () => controller.abort();
  }, [endpoint, JSON.stringify(params), JSON.stringify(headers), skip]);

  return { data, loading, error };
}
